import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}`);
      navigate(user.role === "admin" ? "/admin" : from);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-32 pb-24 grain min-h-screen flex items-center" data-testid="login-page">
      <div className="max-w-md mx-auto w-full px-6">
        <div className="text-center mb-12">
          <div className="eyebrow">Welcome Back</div>
          <h1 className="font-display text-5xl mt-6">Sign In</h1>
          <div className="divider-gold mx-auto" />
        </div>

        <form onSubmit={submit} className="glass-strong p-10 space-y-6" data-testid="login-form">
          <div>
            <Label className="text-xs text-white/60 uppercase tracking-wider">Email</Label>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 bg-[#0f0f0f] border-white/10 h-12"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <Label className="text-xs text-white/60 uppercase tracking-wider">Password</Label>
            <Input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-[#0f0f0f] border-white/10 h-12"
              data-testid="login-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-gold w-full"
            data-testid="login-submit-button"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>

          <div className="text-center text-sm text-white/50">
            Don't have an account?{" "}
            <Link to="/register" className="text-gold hover:underline" data-testid="link-to-register">
              Create one
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
